import ExpensesReport from "@/sales/usecases/expenses-report";

export default class ExpensesReportPresentationModel {
  public constructor(private report: ExpensesReport = new ExpensesReport()) {}

  formatter = Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY"
  });

  profitabilityFormatter = Intl.NumberFormat("ja-JP", {
    style: "percent"
  });

  /**
   * 売上
   */
  //   get expenses(): string {
  //     return this.formatter.format(this.report.expenses);
  //   }

  /**
   * 前年同月比
   */
  //   get expensesComparison(): string {
  //     return this.formatter.format(this.expensesComparisonNum);
  //   }

  /**
   * 売上の変化
   */
  //   get expensesChange(): string {
  //     if (this.expensesComparisonNum > 0) {
  //       return "↑";
  //     }
  //     if (this.expensesComparisonNum < 0) {
  //       return "↓";
  //     }
  //     return "→";
  //   }

  /**
   * 売上の変化の色付け
   */
  //   get expensesChangeColor(): string {
  //     if (this.expensesComparisonNum > 0) {
  //       return "var(--primary)";
  //     }
  //     if (this.expensesComparisonNum < 0) {
  //       return "var(--danger)";
  //     }
  //     return "var(--info)";
  //   }

  /**
   * 請求書の発行枚数
   */
  //   get invoices(): string {
  //     return `${this.report.invoices} 枚`;
  //   }

  /**
   * 発注額
   */
  //   get purchaseAmounts(): string {
  //     return this.formatter.format(this.report.purchaseAmounts);
  //   }

  /**
   * 受注総額
   */
  //   get total(): string {
  //     return this.formatter.format(this.report.total);
  //   }

  /**
   * 発注総額
   */
  //   get purchasesTotal(): string {
  //     return this.formatter.format(this.report.purchasesTotal);
  //   }

  /**
   * 発注書の発行枚数
   */
  //   get purchases(): string {
  //     return `${this.report.purchases} 枚`;
  //   }

  /**
   * 利益率
   */
  //   get profit(): string {
  //     return this.formatter.format(this.report.profit);
  //   }

  /**
   * 表示期間の利益率
   */
  //   get totalProfit(): string {
  //     return this.formatter.format(this.report.totalProfit);
  //   }

  /**
   * 利益率
   */
  //   get profitability(): string {
  //     return this.report.profitability.toFixed(2) + " %";
  //   }

  /**
   * 表示期間の利益率
   */
  //   get totalProfitability(): string {
  //     return this.report.totalProfitability.toFixed(2) + " %";
  //   }

  //   private get expensesComparisonNum() {
  //     return this.report.expenses - this.report.expensesThisMonthLastYear;
  //   }
}
